import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';

export function handlePaginationChangeUtil(
  contentPage: ElementRef,
  setSpinner: (value: boolean) => void,
  router: Router,
  paramName: string,
  paramValue: any
) {
  if (contentPage) {
    contentPage.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  setSpinner(true);
  router.navigate([], {
    queryParams: { [paramName]: paramValue },
    queryParamsHandling: 'merge',
  });
}
